import { render, staticRenderFns } from "./RankUpdown.vue?vue&type=template&id=f499d07c"
import script from "./RankUpdown.vue?vue&type=script&lang=js"
export * from "./RankUpdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports